import { PaletteMode } from '@mui/material';

import projectConfig, { PROJECT } from '~/projects/config';

export const getLoaderAnimationSrc = (themeMode: PaletteMode): string => {
  if (projectConfig.project === PROJECT.POLYLLM_CHAT) {
    return themeMode === 'dark'
      ? '/animations/loader-dark-theme.riv'
      : '/animations/loader-white-theme.riv';
  }

  return '/animations/loader.riv';
};
